/**
 * UI texts of the table view (Phase 3d), kept apart from messages/* and merged into the locale
 * trees by i18n/index.ts. fr / nl fall back to en.
 */
const ops = {
  de: { eq: '=', ne: '≠', lt: '<', le: '≤', gt: '>', ge: '≥', like: 'wie (Muster)', notLike: 'nicht wie (Muster)', in: 'ist eines von', notIn: 'ist keines von', isNull: 'ist NULL', notNull: 'ist nicht NULL', isEmpty: 'ist leer', notEmpty: 'ist nicht leer', findInSet: 'enthält Eintrag', contains: 'enthält', notContains: 'enthält nicht', startsWith: 'beginnt mit', endsWith: 'endet mit' },
  en: { eq: '=', ne: '≠', lt: '<', le: '≤', gt: '>', ge: '≥', like: 'like (pattern)', notLike: 'not like (pattern)', in: 'is one of', notIn: 'is none of', isNull: 'is NULL', notNull: 'is not NULL', isEmpty: 'is empty', notEmpty: 'is not empty', findInSet: 'has entry', contains: 'contains', notContains: 'does not contain', startsWith: 'starts with', endsWith: 'ends with' },
};

export const de = {
  tv: {
    grid: 'Datensätze',
    cards: 'Datensätze',
    toolbar: 'Tabellen-Werkzeuge',
    empty: 'Keine Datensätze gefunden.',
    apply: 'Übernehmen',
    open: 'Öffnen',
    openTab: 'In neuem Tab öffnen',
    edit: 'Bearbeiten',
    copy: 'Kopieren',
    delete: 'Löschen',
    actions: 'Aktionen',
    more: 'Weitere Funktionen',
    print: 'Drucken …',
    savedPrints: 'Gespeicherte Drucke',
    export: 'Exportieren …',
    import: 'Importieren …',
    sqlFunctions: 'SQL-Funktionen (folgt)',
    contextMenu: 'Kontextmenü',
    loadMore: 'Weitere laden',
    lockedBy: 'Wird bearbeitet von {user}',
    newRecords: '{n} neue Datensätze – anzeigen',
    confirmDelete: '{n} Datensatz/Datensätze wirklich löschen?',
    deleted: '{n} gelöscht.',
    confirmRemoveSaved: 'Wirklich löschen?',
    savedOk: 'Gespeichert.',
    copied: 'In die Zwischenablage kopiert.',
    copyFailed: 'Kopieren nicht möglich.',
    copyCell: 'Zelle kopieren',
    copyRow: 'Zeile kopieren',
    filterSet: 'Filter: nur dieser Wert ({col})',
    filterAdd: 'Filter ergänzen: dieser Wert ({col})',
    filterNot: 'Filter ergänzen: ohne diesen Wert ({col})',
    simpleSearch: 'Suchen …',
    activeFilters: 'Aktive Filter',
    paging: 'Seiten',
    colMenu: 'Spaltenmenü {col}',
    range: { desktop: 'Datensätze {from}–{to} von {total}', mobile: '{n} von {total} Datensätzen', none: '0 Datensätze' },
    page: { label: 'Seite', of: 'von {n}', first: 'Erste Seite', prev: 'Vorige Seite', next: 'Nächste Seite', last: 'Letzte Seite', size: 'Pro Seite', all: 'alle (max. {n})' },
    search: {
      title: 'Suchen',
      toggle: 'Suchzeile ein-/ausblenden',
      apply: 'Suchen',
      in: 'Suche in {col}',
      or: 'ODER-Zeile hinzufügen',
      removeOr: 'ODER-Zeile entfernen',
      orPlaceholder: 'oder …',
      syntax: 'Syntax: = != < > <= >= LIKE NOT LIKE NULL !NULL EMPTY !EMPTY, * als Platzhalter, || für oder.',
    },
    sort: { title: 'Sortieren', asc: 'Aufsteigend', desc: 'Absteigend', add: 'Zur Sortierung hinzufügen', remove: 'Aus Sortierung entfernen', column: 'Spalte', direction: 'Richtung' },
    col: { hide: 'Spalte ausblenden', mark: 'Spalte markieren', unmark: 'Markierung entfernen', left: 'Nach links', right: 'Nach rechts', filter: 'Filtern …', resize: 'Breite von {col} ändern' },
    group: { by: 'Gruppieren nach', badge: 'Gruppe', chip: 'Gruppiert: {cols}', clear: 'Gruppierung aufheben', drill: 'Datensätze dieser Gruppe zeigen' },
    agg: { title: 'Aggregat', SUM: 'Summe', AVG: 'Mittel', MIN: 'Min', MAX: 'Max', COUNT: 'Anzahl' },
    footer: { title: 'Summenzeile', page: 'Diese Seite', total: 'Gesamtes Ergebnis' },
    select: { all: 'Alle auswählen', none: 'Auswahl aufheben', row: 'Zeile {n} auswählen', record: '{title} auswählen', start: 'Auswählen', stop: 'Auswahl beenden' },
    bulk: { title: 'Auswahl', count: '{n} ausgewählt', edit: 'Bearbeiten (folgt)' },
    chip: { remove: '{what} entfernen', searchRow: 'Suchzeile ({n})', clearAll: 'Alle Filter entfernen' },
    filter: {
      title: 'Filter',
      edit: 'Filter bearbeiten',
      and: 'UND',
      or: 'ODER',
      not: 'NICHT',
      combine: 'Verknüpfung',
      column: 'Spalte',
      operator: 'Operator',
      value: 'Wert',
      listHint: 'Werte mit Komma trennen',
      addCondition: 'Bedingung',
      addGroup: 'Gruppe',
      removeCondition: 'Bedingung entfernen',
      removeGroup: 'Gruppe entfernen',
      emptyGroup: 'Keine Bedingungen.',
      summary: 'Filter',
      hits: '{n} Treffer',
      clear: 'Leeren',
      save: 'Speichern als …',
      apply: 'Anwenden',
    },
    op: ops.de,
    saved: { filters: 'Gespeicherte Filter', mine: 'Meine Filter', groups: 'Gruppenfilter', none: 'Keine gespeicherten Filter.', remove: '{name} löschen', saveCurrent: 'Aktuelle Suche speichern' },
    save: { name: 'Name', owner: 'Für', me: 'Nur mich', group: 'Gruppe {group}', default: 'Als Standard verwenden' },
    view: {
      menu: 'Ansicht',
      saved: 'Gespeicherte Ansichten',
      default: 'Standard',
      defaultName: 'Standard',
      tableDefault: 'Tabellenstandard',
      saveActive: '„{name}“ aktualisieren',
      saveDefault: 'Als meinen Standard speichern',
      saveAs: 'Ansicht speichern als',
    },
    columns: {
      title: 'Spalten',
      available: 'Verfügbar',
      selected: 'Angezeigt',
      filter: 'Spalten filtern',
      add: '{col} anzeigen',
      remove: '{col} ausblenden',
      up: '{col} nach oben',
      down: '{col} nach unten',
      mark: '{col} markieren',
      reset: 'Tabellenstandard',
    },
    quickEdit: { start: 'Schnell bearbeiten', readonly: 'Dieses Feld ist hier nicht bearbeitbar.', saving: 'Speichert …' },
    mode: { label: 'Darstellung', grid: 'Tabelle', cards: 'Karten', status: 'Status' },
  },
  shortcuts: {
    table_left: 'Zelle links',
    table_right: 'Zelle rechts',
    table_select: 'Zeile auswählen',
    table_search: 'Suchen',
    table_filter: 'Filter-Baukasten',
    table_pageNext: 'Nächste Seite',
    table_pagePrev: 'Vorige Seite',
    table_print: 'Drucken',
    record_print: 'Datensatz drucken',
    record_compare: 'Mit Live-Daten vergleichen',
  },
};

export const en: typeof de = {
  tv: {
    grid: 'Records',
    cards: 'Records',
    toolbar: 'Table tools',
    empty: 'No records found.',
    apply: 'Apply',
    open: 'Open',
    openTab: 'Open in new tab',
    edit: 'Edit',
    copy: 'Copy',
    delete: 'Delete',
    actions: 'Actions',
    more: 'More functions',
    print: 'Print …',
    savedPrints: 'Saved prints',
    export: 'Export …',
    import: 'Import …',
    sqlFunctions: 'SQL functions (coming)',
    contextMenu: 'Context menu',
    loadMore: 'Load more',
    lockedBy: 'Being edited by {user}',
    newRecords: '{n} new records – show',
    confirmDelete: 'Really delete {n} record(s)?',
    deleted: '{n} deleted.',
    confirmRemoveSaved: 'Really delete?',
    savedOk: 'Saved.',
    copied: 'Copied to the clipboard.',
    copyFailed: 'Copying is not possible.',
    copyCell: 'Copy cell',
    copyRow: 'Copy row',
    filterSet: 'Filter: only this value ({col})',
    filterAdd: 'Add filter: this value ({col})',
    filterNot: 'Add filter: without this value ({col})',
    simpleSearch: 'Search …',
    activeFilters: 'Active filters',
    paging: 'Pages',
    colMenu: 'Column menu {col}',
    range: { desktop: 'Records {from}–{to} of {total}', mobile: '{n} of {total} records', none: '0 records' },
    page: { label: 'Page', of: 'of {n}', first: 'First page', prev: 'Previous page', next: 'Next page', last: 'Last page', size: 'Per page', all: 'all (max. {n})' },
    search: {
      title: 'Search',
      toggle: 'Show / hide search row',
      apply: 'Search',
      in: 'Search in {col}',
      or: 'Add OR row',
      removeOr: 'Remove OR row',
      orPlaceholder: 'or …',
      syntax: 'Syntax: = != < > <= >= LIKE NOT LIKE NULL !NULL EMPTY !EMPTY, * as wildcard, || for or.',
    },
    sort: { title: 'Sort', asc: 'Ascending', desc: 'Descending', add: 'Add to sorting', remove: 'Remove from sorting', column: 'Column', direction: 'Direction' },
    col: { hide: 'Hide column', mark: 'Mark column', unmark: 'Remove mark', left: 'Move left', right: 'Move right', filter: 'Filter …', resize: 'Resize {col}' },
    group: { by: 'Group by', badge: 'Group', chip: 'Grouped: {cols}', clear: 'Remove grouping', drill: 'Show the records of this group' },
    agg: { title: 'Aggregate', SUM: 'Sum', AVG: 'Avg', MIN: 'Min', MAX: 'Max', COUNT: 'Count' },
    footer: { title: 'Totals', page: 'This page', total: 'Whole result' },
    select: { all: 'Select all', none: 'Clear selection', row: 'Select row {n}', record: 'Select {title}', start: 'Select', stop: 'End selection' },
    bulk: { title: 'Selection', count: '{n} selected', edit: 'Edit (coming)' },
    chip: { remove: 'Remove {what}', searchRow: 'Search row ({n})', clearAll: 'Remove all filters' },
    filter: {
      title: 'Filter',
      edit: 'Edit filter',
      and: 'AND',
      or: 'OR',
      not: 'NOT',
      combine: 'Combination',
      column: 'Column',
      operator: 'Operator',
      value: 'Value',
      listHint: 'Separate values with commas',
      addCondition: 'Condition',
      addGroup: 'Group',
      removeCondition: 'Remove condition',
      removeGroup: 'Remove group',
      emptyGroup: 'No conditions.',
      summary: 'Filter',
      hits: '{n} hits',
      clear: 'Clear',
      save: 'Save as …',
      apply: 'Apply',
    },
    op: ops.en,
    saved: { filters: 'Saved filters', mine: 'My filters', groups: 'Group filters', none: 'No saved filters.', remove: 'Delete {name}', saveCurrent: 'Save current search' },
    save: { name: 'Name', owner: 'For', me: 'Only me', group: 'Group {group}', default: 'Use as default' },
    view: {
      menu: 'View',
      saved: 'Saved views',
      default: 'Default',
      defaultName: 'Default',
      tableDefault: 'Table default',
      saveActive: 'Update “{name}”',
      saveDefault: 'Save as my default',
      saveAs: 'Save view as',
    },
    columns: {
      title: 'Columns',
      available: 'Available',
      selected: 'Shown',
      filter: 'Filter columns',
      add: 'Show {col}',
      remove: 'Hide {col}',
      up: 'Move {col} up',
      down: 'Move {col} down',
      mark: 'Mark {col}',
      reset: 'Table default',
    },
    quickEdit: { start: 'Quick edit', readonly: 'This field cannot be edited here.', saving: 'Saving …' },
    mode: { label: 'Display', grid: 'Table', cards: 'Cards', status: 'Status' },
  },
  shortcuts: {
    table_left: 'Cell to the left',
    table_right: 'Cell to the right',
    table_select: 'Select row',
    table_search: 'Search',
    table_filter: 'Filter builder',
    table_pageNext: 'Next page',
    table_pagePrev: 'Previous page',
    table_print: 'Print',
    record_print: 'Print the record',
    record_compare: 'Compare with live data',
  },
};

export const tableTexts: Partial<Record<'de' | 'en' | 'fr' | 'nl', Record<string, unknown>>> = { de, en };
